import styled from 'styled-components';

const LoadingWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const MessageComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  max-width: 300px;
`;

export {
  LoadingWrapper,
  MessageComponentWrapper,
};
